import axios from 'axios'
import { ThemeValidationResult, ThemeValidationParameters, Theme } from '../features/theme/types'

export const fetchThemes = () => axios.get('/themes')

export const fetchThemeInfo = (entityId: any) => axios.get<Theme>(`/themes/${entityId}`)

export const validateTheme = (theme: ThemeValidationParameters) =>
  axios.post<ThemeValidationResult>('/themes/validate', theme)

export const saveTheme = (theme: ThemeValidationParameters) => axios.post<Theme>('/themes', theme)

export const updateTheme = (entityId: string, data: ThemeValidationParameters) =>
  axios.put<Theme>(`/themes/${entityId}`, data)

export const deleteTheme = (entityId: string) => axios.delete(`/themes/${entityId}`)
